
  import { Vue, Component, Prop } from "vue-property-decorator";
  import CardItemTitle from "@/components/card/CardItemTitle.vue";
  import CardItemValue from "@/components/card/CardItemValue.vue";
  import RouteParams from "@/entities/RouteParams";

  @Component({
    components: {
      CardItemValue,
      CardItemTitle,
    },
  })
  export default class CardItemBaseContainer extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String, default: undefined }) readonly value?: string;
    @Prop({ type: Boolean, default: false }) readonly highlightValue!: boolean;
    @Prop({ type: Object, default: () => ({}) }) readonly routeParams!: Partial<RouteParams<{ id: string }>>;
  }
